<template>
  <section :class="`ryoma-page-${$route.name}`">

    <Drivers />

    <ServicesArchives />

  </section>
</template>

<script>
// @ is an alias to /src
import Drivers from '@/partials/Drivers.vue'
import ServicesArchives from '@/views/ServicesArchives.vue'

export default {
  name: 'home',
  components: {
    Drivers,
    ServicesArchives
  }
}
</script>
